import { formatNode } from "../node/formatNode.js";
import {} from "../node/index.js";
import {} from "./Net.js";
import { findNodeEntry } from "./findNodeEntry.js";
export function findPortRecordOrFail(net, node) {
    const nodeEntry = findNodeEntry(net, node);
    if (nodeEntry === undefined) {
        throw new Error([
            `[findPortRecordOrFail] I can not find node entry for node.`,
            ``,
            `  node: ${formatNode(net, node)}`,
        ].join("\n"));
    }
    return nodeEntry.ports;
}
//# sourceMappingURL=findPortRecordOrFail.js.map